export default function ListItem(props) {
  var visited = props.visited ? "***" : "";

  return (
    <div onClick={() => props.onClick()}>
      {props.item[0]} {visited}
    </div>
  );
}
